module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {}, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Plumbing'
    }
  }, [_vm._v("Plumbing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Roofing'
    }
  }, [_vm._v("Roofing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Tiling'
    }
  }, [_vm._v("Tiling")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'cnpro-search?context=Airconditioner'
    }
  }, [_vm._v("Airconditioning")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Food Beverage'
    }
  }, [_vm._v("Food & Beverage")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Hotels'
    }
  }, [_vm._v("Hotels")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Home Services'
    }
  }, [_vm._v("Home Services")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": 'business-search?context=Event Planning'
    }
  }, [_vm._v("Event Planning")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-bottom-left"
  }, [_vm._v("\r\n                    © " + _vm._s(_vm.this_year) + " All rights reserved. cityneeds.\r\n                ")]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "cnpros"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("CNpro CATEGORIES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "businesses"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("BUSINESS CATEGORIES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": "about"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("ABOUT")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "about"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "how-it-works"
    }
  }, [_vm._v("How CNpro Works")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "pricing"
    }
  }, [_vm._v("CNpro Plans & Pricing")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "insuremoto"
    }
  }, [_vm._v("InsureMoto")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "discountbazaar"
    }
  }, [_vm._v("DiscountBazaar")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "terms"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "policy"
    }
  }, [_vm._v("Privacy & Policy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": "forums"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("COMMUNITY")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "forums"
    }
  }, [_vm._v("Forum")]), _vm._v("   "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "https://www.blog.cityneeds.ng",
      "target": "_blank"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("    08032258453")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("   Visit Us:"), _c('br'), _vm._v("\r\n                                    P53A, Emirate Lane, Sunnyvale Estate,\r\n                                    Abuja, Nigeria.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom-right"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "about"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "terms"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "policy"
    }
  }, [_vm._v("Privacy & Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("08032258453")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0f547b"}!./src/components/Main-Footer/template.html
// module id = 285
// module chunks = 0